import { threatSeverity, type RatingSeverity } from '@/lib/owaspRating';

const SEVERITY_COLORS: Record<RatingSeverity, string> = {
  critical: 'bg-red-600 text-white ring-red-600/20 dark:bg-red-600 dark:text-white',
  high: 'bg-red-100 text-red-800 ring-red-600/20 dark:bg-red-900/30 dark:text-red-400',
  medium: 'bg-yellow-100 text-yellow-800 ring-yellow-600/20 dark:bg-yellow-900/30 dark:text-yellow-400',
  low: 'bg-green-100 text-green-800 ring-green-600/20 dark:bg-green-900/30 dark:text-green-400',
  note: 'bg-sky-100 text-sky-800 ring-sky-600/20 dark:bg-sky-900/30 dark:text-sky-400',
  unrated: 'bg-gray-100 text-gray-800 ring-gray-600/20 dark:bg-gray-900/30 dark:text-gray-400',
};

export function severityColor(severity: RatingSeverity): string {
  return SEVERITY_COLORS[severity];
}

interface SeverityBadgeProps {
  vector?: string | null;
  threatType?: string | null;
  /** Render nothing for unrated threats (default) instead of an "UNRATED" badge. */
  showUnrated?: boolean;
}

/** OWASP Risk Rating severity of a Threat, computed like ThreatCat's `rating_severity`. */
export default function SeverityBadge({ vector, threatType, showUnrated = false }: SeverityBadgeProps) {
  const severity = threatSeverity(vector, threatType);
  if (severity === 'unrated' && !showUnrated) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold ring-1 ring-inset ${severityColor(severity)}`}
      title={vector?.trim() || undefined}
    >
      {severity.toUpperCase()}
    </span>
  );
}
